import languages from '../assets/data/lang.json';
import getLanguageFromLocalStorage from './getLanguageFromLocalStorage';
import getMomentLangFromi18n from './getMomentLangFromi18n';

export default function getLanguageCode() {
  const language = languages.find(l => l.value === getLanguageFromLocalStorage()) || languages[0];
  return getMomentLangFromi18n(language.value);
}
